/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Textarea wrapper
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.11.0
 */

import React, { ChangeEvent, ReactElement } from 'react';

import { fonts } from '../../../theme';
import { EInputKind } from '../Input/Input';
import { LabelHintStyled, LabelMarkStyled, LabelStyled } from '../Input/styled/InputStyled';
import { TextareaStyled } from './styled/TextareaStyled';

interface ITextareaProps {
    dataName?: string;
    kind?: EInputKind;
    label?: string;
    labelHint?: ReactElement;
    onChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
}

const Textarea = (props: ITextareaProps & React.HTMLProps<HTMLTextAreaElement>) => {
    const { dataName, kind, label, labelHint, ...rest } = props;

    return (
        <TextareaStyled data-name={dataName} font={fonts.textMain} kind={kind}>
            {label && (
                <LabelStyled
                    className={'textarea-label'}
                    kind={kind ? kind : EInputKind.normal}
                    labelFont={fonts.textMainBold}
                >
                    {label}
                    {rest.required && <LabelMarkStyled className={'textarea-label-required'}>*</LabelMarkStyled>}
                </LabelStyled>
            )}
            {labelHint && <LabelHintStyled>{labelHint}</LabelHintStyled>}
            <textarea {...rest} />
        </TextareaStyled>
    );
};

Textarea.defaultProps = {
    kind: EInputKind.normal,
    label: '',
    onChange: () => {},
    required: false,
};

export default Textarea;
